import { IMinerStatusesModal } from "@components/modals/newModals/MinerStatusesModel/MinerStatusesModal.props";
import { getMathValues2, IMathValues } from "@components/Pages/Locations/LocationRow/LocationMore/LocationChart/Statistic.control";
import { DRAGGING_TYPES, IBuildingName } from "@components/Pages/Locations/LocationRow/LocationMore/LocationMore.control";
import {
  IMergedSection,
  IPositionedRackTable,
  IRackSection,
  IRackTable, IReceivedRackTable,
  isMinerItem,
  isRackItem,
  RACK_SECTION_TYPE, TypePartialRackItem
} from "@components/Pages/Locations/LocationRow/LocationMore/RackTable/Rack/Rack.props";
import {
  IBackRackItemType,
  IRackItem,
  IRackItemBase
} from "@components/Pages/Locations/LocationRow/LocationMore/RackTable/Rack/RackItem/RackItem.props";
import { LOCATION_PARAMS } from "@components/Pages/Machines/MinerRow/MinerLocation/useMinerLocationControl";
import { RecievedFullMinerInfo } from "@services/getMinerInfo";
import { IColoredUser } from "@services/getUsers";
import { ILocation, ILocationForList } from "@services/locations";
import { IUpdateRackPosition, ObjectResponse } from "@services/rackService";
import { IAvailableRack, IAvailableRackItem } from "@store/availableLocationRacks/actionTypes";
import { IAvailableEquipment } from "@store/Equipments/actionTypes";
import { IUnrackItem } from "@store/unallocatedMiners/actionTypes";
import { isStateOn3 } from "../connections";

/** FYI
 interface IEquipment {
  readonly id: string;
  readonly name: string;
  readonly type: EQUIPMENT_TYPE;
  readonly info?: string;
  readonly color: string; // - hex
}

export interface IWorkEquipment extends IEquipment {
  readonly num: number;
  readonly on?: boolean;
  readonly subtype?: NodeType
}

export interface IBackRackItemType extends IWorkEquipment {
  readonly info?: string;
}

*/

// Типы для оборудования, которое может быть на задней панели майнера
export type IBackRackItemType3 = IBackRackItemType;

/** FYI
export interface IRackItemBase {
  readonly id: number;
  readonly pos: RACK_SECTION_TYPE;
  readonly x: number;
  readonly y: number;
  readonly found?: boolean;
}

export interface IRackItem extends IRackItemBase {
  //front
  readonly miner_id: number;
  readonly miner_name: string;
  readonly user_color: string;
  readonly user_id: string;
  readonly status: MINER_STATUSES_E;
  readonly rejected?: number;
  readonly accepted?: number;
  readonly merge?: number[]; // массив id итемов
  readonly meta?: string;
  readonly speed?: number;
  readonly reproxy_link: IReproxyLink;
  //back
  readonly types?: IBackRackItemType[];
}

export interface IMergedSection extends IRackItem {
  readonly merged: boolean;
}

export interface IRackSection extends IRackItemBase { }
export type TypePartialRackItem = IRackItem | IMergedSection | IRackSection;

*/

export type IRackItemBase3 = IRackItemBase;

// Интерфейс для майнера, расположенного в стойке
export type IRackItem3 = Omit<IRackItem, "user_id"> & {
  user_id: number;
  merged?: boolean;
};

export const toRackItem3 = (item: IRackItem): IRackItem3 => ({ ...item, user_id: +item.user_id });
export const fromRackItem3 = (item: IRackItem3): IRackItem => ({ ...item, user_id: "" + item.user_id });

export const isRackItem3 = isRackItem;

// Интерфейс для объединенной секции (части майнера, занимающей несколько ячеек)
export type IMergedSection3 = IMergedSection;

// Тип для частичного элемента стойки (может быть как майнер, так и пустая/неактивная ячейка)
export type TypePartialRackItem3 = TypePartialRackItem;

export type ISomeItem = IUnrackItem3 | TypePartialRackItem3;
export type ISomeMinerItem = IUnrackItem3 | IRackItem3;

/** FYI
export interface IRackTable {
  readonly id: string;
  readonly rack_id: string;
  readonly rack_items: TypePartialRackItem[];
  readonly rack_type: [number, number];
  readonly found?: boolean;
}
*/
// Интерфейс для информации о стойке
export type IRack = Omit<IRackTable, 'id'> & {
  id: number;
};

export const toRack = (r: IRackTable): IRack => ({ ...r, id: +r.id });
export const isIRack = (item: any): item is IRack => Array.isArray((item as IRackTable)?.rack_items);

/** FYI
export interface UserI {
  id: string;
  email: string;
  name?: string;
  color: string;
  is_admin?: boolean;
  tags?: string; // JSON
  contractids?: string;
  contractnames?: string;
  Urole?: "a" | "u" | "t";
}

export interface IColoredUser extends UserI {}
*/

// Интерфейс для цветного пользователя (из API GetUserById)
export type IColoredUser3 = Omit<IColoredUser, "id"> & {
  id: number;
};

export const toColoredUser3 = (u: IColoredUser): IColoredUser3 => ({ ...u, id: +u.id });


/** FYI

export interface ReceivedMinerDataI {
  id: number;
  miner_id: string;
  unknown_miner_id?: string;
  profile: IMinerProfileBase;
  hash: ALGOS_E;
  speed_default: number;
  speed_current: number;
  accepted?: number;
  rejected?: number;
  speed_drop: number;
  setting: string;
  settingid: number;
  status: MINER_STATUSES_E;
  location: string;
  location_id: string;
  tags?: string;
  user_color?: string;
  node?: string;
}

export interface IReceivedAdminMinerData extends ReceivedMinerDataI {
  customer_id?: string;
  customer_email?: string;
  admin_mining_do?: boolean;
  has_errors?: boolean;
}

export interface IMinerAdditionalData extends BaseMinerAdditionalDataI {
  location_raw?: MinerLocationRaw;
  photos?: string[];
  meta?: IMinerMeta;
  chat: MinerChatMessage[];
  //reproxy_link?: IReproxyLink;
}

export interface BaseMinerAdditionalDataI {
  admin_notes?: NoteI[];
  user_note?: string;
  notifications: string[];
  plan: IMiningPlanOptions;
  smooth?: boolean;
}

export interface IAdminMinerAdditionalData {
  admin_note: string;
  sync_note: string;
  proof: number; // mining admin %
  admin_mining_proof?: IAdminMinerProof[];
  admin_mining_setting?: string;
  photos?: string[];
  meta?: IMinerMeta;
  chat: MinerChatMessage[];
  uuid?: string;
  contract_id?: number;
  contract_name?: string;
  installed?: string;
  reproxy_link?: IReproxyLink;
}

export interface IAdminMinerTable
  extends IReceivedAdminMinerData,
  IMinerAdditionalData,
  IAdminMinerAdditionalData {
  readonly isSelected?: boolean;
  //readonly reproxy_link?: IReproxyLink;
} 

export interface ReceivedMinerInfoI extends BaseMinerAdditionalDataI {
  Id: number;
  location?: MinerLocationRaw;
}

export interface ReceivedAdminMinerInfoI
  extends ReceivedMinerInfoI,
  IAdminMinerAdditionalData { }

export interface RecievedFullMinerInfo
  extends Omit<IAdminMinerTable, "location">,
  ReceivedAdminMinerInfoI { }
*/
// Интерфейс для информации о майнере (из API GetFullMinerInfo)
export type IMinerFullInfo3 = RecievedFullMinerInfo;

/** FYI
export interface IDragRackItemData extends IRackItem {
  readonly prevRackId: string;
  readonly prevIndex: number;
}
*/

interface IDragRackItemData extends IRackItem {
  readonly prevRackId: string;
  readonly prevIndex: number;
}

// Интерфейс для данных о перетаскиваемом элементе стойки
export type IDragRackItemData3 = Omit<IDragRackItemData, "user_id"> & {
  user_id: number;
};


/** FYI
export type IUnrackItem = Omit<IRackItem, "pos" | "miner_id">;
*/
// Интерфейс для данных о перетаскиваемом нераспределенном майнере
export type IUnrackItem3 = Omit<IUnrackItem, "user_id"> & {
  user_id: number;
};

// Интерфейс для активной секции
export interface IActiveSection {
  selectedId: string;
  rackItem: IRackItem3;
}

// Интерфейс для активной стойки
export interface IActiveRack {
  id: string;
  rack_id: string;
  rack_type: [number, number];
}


export const RACK_SECTION_TYPE3 = RACK_SECTION_TYPE;
export type RACK_SECTION_TYPE3 = RACK_SECTION_TYPE;

export type IPositionedRackTable3 = Omit<IPositionedRackTable, 'id'> & {
  id: number;
};

export const fillLocationRacks3 = (
  racks: IReceivedRackTable[]
): IPositionedRackTable3[] => {
  const filled: IPositionedRackTable3[] = racks.map((rack) => {
    return {
      ...rack,
      id: +rack.id,
      rack_items: [...rack.rack_items],
      rack_pos: { row: rack.y - 1, col: rack.x - 1 },
    };
  });
  return filled;
};

export const DRAGGING_TYPES3 = DRAGGING_TYPES;
export type DRAGGING_TYPES3 = DRAGGING_TYPES;

export type ILocation3 = Omit<ILocationForList, "Id"> & {
  Id: number;
}

export type ILocationData = Omit<ILocation3, "Id">;

export type ILocationStrings = ILocation;
export type ILocationStringsData = Omit<ILocationStrings, "Id">;

export type IBuilding = Omit<ObjectResponse, "id"> & {
  id: number;
}

export interface IMinerLog3 {
  readonly id: number; // miner hash || number
  readonly prev: string;
  readonly next: string;
}

export interface IRackItemForRack3 extends IRackItem3 {
  rackID: number;
}

export const isPostitionedRackTable3 = (
  r: IRack
): r is IPositionedRackTable3 =>
  (r as IPositionedRackTable3).rack_pos !== undefined;

export interface ITemporaryRack {
  rack: IRack;
  templateID: string;
}

export type IUpdateRackPosition3 = Omit<IUpdateRackPosition, "id"> & {
  id: number;
};

export type IRackTemplate = IAvailableRack;
export type MoveType3 = "prev" | "next";

export interface IRackSection3 extends Omit<IRackSection, "id"> {
  readonly id?: number;
}

export type IRackTemplateItem = IAvailableRackItem;
export type IEquipmentTemplate = IAvailableEquipment;
export type IBuildingName3 = Omit<IBuildingName, "id"> & {
  id: number;
};

export const isMinerItem3 = isMinerItem;

export interface IBuildingWithMiners extends IBuilding {
  miners: IRackItem3[];
}

export const recalcBuildingOnOff3 = (data: IBuildingWithMiners): IBuildingWithMiners => {
  let on = 0,
    off = 0;

  for (const m of data.miners) {
    const [dOn, dOff] = isStateOn3(m.status) ? [1, 0] : [0, 1];
    on += dOn;
    off += dOff;
  }

  return {
    ...data,
    m_online: on,
    m_offline: off,
  };
};

export type MinerStatusInModal = IMinerStatusesModal["status"];

export type IMathValues3 = IMathValues;
export const getMathValues3 = getMathValues2;

export type LOCATION_PARAMS3 = LOCATION_PARAMS;
export const LOCATION_PARAMS3 = LOCATION_PARAMS;
